import React from "react";
import Styles from "../ConnectionAcceptModal/ConnectionAcceptModal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactComponent as SuccessIcon } from "../../../../assets/images/success.svg";

const SuccessPop = ({ open, handleClose, onConfirm }) => {
  return (
    <div>
      <div>
        <>
          <Modal open={open} onClose={handleClose}>
            <div className={` ${Styles.createEditModalCont}`}>
              <div
                style={{ backgroundColor: " #fffffff0;" }}
                className={Styles.headerSection}
              >
                <div>
                  <SuccessIcon style={{ width: "60px", height: "60px" }} />
                </div>
                <span>Allf files have been</span>
                <span>successfully verified.</span>
              </div>
            </div>
          </Modal>
        </>
      </div>
    </div>
  );
};

export default SuccessPop;
